module.exports = __webpack_public_path__ + "img/section-1_bottom_img.c33a562b.png";